export const Blockchain = {
	ETHEREUM: 'ethereum',
	POLYGON: 'polygon',
	FANTOM: 'fantom',
	ALCHEMY: 'alchemy',
	ARBITRUM: 'arbitrum',
	OPTIMISM: 'optimism',
};

export const BlockchainIconMap = {
	[Blockchain.ETHEREUM]: '/assets/images/ethereum.png',
	[Blockchain.POLYGON]: '/assets/images/polygon.png',
	[Blockchain.FANTOM]: './assets/images/fantom.png',
	[Blockchain.ALCHEMY]: '/assets/images/alchemy.png',
	[Blockchain.ARBITRUM]: '/assets/images/arbitrum.png',
	[Blockchain.OPTIMISM]: '/assets/images/optimism.png',
};
